import { VStack } from '@chakra-ui/react';

const MenuList = ({ children }) => {
  return (
    <VStack
      justifyContent="flex-start"
      alignItems="flex-start"
      paddingTop={[0, 0, '32px']}
      minWidth={['100%', '100%', '60%']}
      maxWidth="600px"
      spacing="16px"
    >
      {children}
    </VStack>
  );
};

export default MenuList;